import {initialState} from "../initialState";
import {
    CLEAR_HISTORY,
    SEEK_BEGAN, SEEK_CELLS_BEGAN, SEEK_CELLS_COMPLETE, SEEK_CELLS_FAILED, SEEK_CELLS_SUCCESS, SEEK_COMPLETE,
    SEEK_FAILED,
    SEEK_SUCCESS, SET_CELLS, SET_FETCH_ID,
    UPDATE_BEGAN, UPDATE_CELLS_BEGAN, UPDATE_CELLS_FAILED, UPDATE_CELLS_SUCCESS,
    UPDATE_FAILED,
    UPDATE_SUCCESS
} from "../actionTypes/history";
import moment from "moment";


const historyReducer = (state = initialState.history, action) => {
    switch (action.type) {
        case SET_FETCH_ID:
            return {
                ...state,
                fetchId: action.payload
            }

        case CLEAR_HISTORY:
            return initialState.history
        case UPDATE_BEGAN:
            return {
                ...state,
                fetching: true,
            }

        case UPDATE_SUCCESS:
            return {
                ...state,
                fetching: false,
                states: [...action.payload, ...state.states],
                lastUpdated: moment(),
            }

        case UPDATE_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }

        case SEEK_BEGAN:
            if (action.payload === state.stateBatteryId) {
                return {
                    ...state,
                    seeking: true
                }
            } else {
                return {
                    ...state,
                    states: [],
                    seeking: true,
                    page: 0,
                    stateBatteryId: action.payload
                }
            }

        case SEEK_SUCCESS:
            return {
                ...state,
                states: [...state.states, ...action.payload.states],
                page: action.payload.page
            }

        case SEEK_COMPLETE:
            return {
                ...state,
                seeking: false
            }

        case SEEK_FAILED:
            return {
                ...state,
                seeking: false,
                error: action.payload
            }

        case SET_CELLS:
            return {
                ...state,
                cells: action.payload
            }

        case UPDATE_CELLS_BEGAN:
            return {
                ...state,
                fetching: true,
            }

        case UPDATE_CELLS_SUCCESS: {
            let states = action.payload.map(st => {
                let curSt = state.cellStates.find(s => s.cellId === st.cellId)
                if (curSt) st.states = [...curSt.states, ...st.states]
                return st
            })

            states = states.sort((a, b) => (a.cellId > b.cellId) ? 1 : -1)

            return {
                ...state,
                fetching: false,
                cellStates: states,//[...action.payload, ...state.cellStates],
                lastUpdated: moment(),
            }
        }
        case UPDATE_CELLS_FAILED:
            return {
                ...state,
                fetching: false,
                error: action.payload
            }

        case SEEK_CELLS_BEGAN:
            if(action.payload === state.cellStateBatteryId){
                return {
                    ...state,
                    seeking: true
                }
            }else {
                return {
                    ...state,
                    //cellStates: [],
                    cellPage: 0,
                    seeking: true,
                    cellStateBatteryId: action.payload
                }
            }

        case SEEK_CELLS_SUCCESS:
            let states = action.payload.states.map(st => {
                let curSt = state.cellStates.find(s => s.cellId === st.cellId)
                if(curSt) st.states = [...curSt.states, ...st.states]
                return st
            })
            console.log()
            states = states.sort((a, b) => (a.cellId > b.cellId) ? 1 : -1)

            return {
                ...state,
                // cellStates: [...state.cellStates, ...action.payload.states],
                cellStates: states,
                cellPage: action.payload.page
            }

        case SEEK_CELLS_COMPLETE:
            return {
                ...state,
                seeking: false
            }

        case SEEK_CELLS_FAILED:
            return {
                ...state,
                seeking: false,
                error: action.payload
            }

        default:
            return state
    }
}

export default historyReducer

// Selector

export const pageSelector = state => state.history.page
export const cellPageSelector = state => state.history.cellPage
export const historySelector = state => state.history.states
export const cellHistorySelector = state => state.history.cellStates
export const updateFetchingSelector = state => state.history.fetching
export const historyseekingSelector = state => state.history.seeking
export const lastStateSelector = state => state.history.states[0]
export const lastCellStatesSelector = state => state.history.cellStates?state.history.cellStates.map(c => c.states.find(s => s.all)):null//.slice(0, cellsCountSelector(state))
export const fetchIdSelector = state => state.history.fetchId
export const cellsSelector = state => state.history.cells
export const cellsCountSelector = state => state.history.cells?state.history.cells.length:null
export const lastUpdatedHistorySelector = state => state.history.lastUpdated